import React from "react"
import Favourites from "../../../BurgerFavourites"
import Links from "../../../BurgerQuickLinks"
import MyAccount from "../../../BurgerMyAcccount"
import CountrySelector from "../../../BurgerCountrySelector"

export const BurgerQuicklinksContainer = () => {
    return (
        <>
            <MyAccount />
            <Favourites />
            <Links />
            <CountrySelector />
        </>
    )
}
export default BurgerQuicklinksContainer
